__turbopack_context__.v({
  "root": "FAQSection-module__RybvXq__root",
});
